import Håkon from "images/håkon.jpg";
import Glenn from "images/glenn.jpg";
import Kim from "images/kim.jpg";
import Akam from "images/akam.jpg";
import Julie from "images/julie.jpg";
import Jonas from "images/jonas.jpg";


export const reviews = [
  {
    rating: 5,
    reviewText:
      '"Great product which made my life so much easier. Now I dont need to spend time buying and editing my business cards ever again! Simple to use and fantastic customer service from the Techhype team."',
    image: Håkon,
    name: "Håkon E.",
  },
  {
    rating: 4.5,
    reviewText:
      '"I am impressed with Techhype\'s digital business card solution! It has made networking so much easier and more efficient. The sleek design and interactive features have definitely helped me leave a lasting impression on potential clients."',
    image: Glenn,
    name: "Glenn L.",
  },
  {
    rating: 5,
    reviewText:
      "\"Techhype's digital business card has revolutionized the way I connect with others. It's incredibly user-friendly, customizable, and has all the essential features I need. Thanks to Techhype, I've streamlined my networking efforts and made a great impression on prospects.\"",
    image: Kim,
    name: "Kim H.",
  },
  {
    rating: 5,
    reviewText:
      '"As a small business owner, Techhype\'s digital business card has been a game-changer. It has given me a professional edge and helped me stand out in a competitive market. The ability to add videos and links to my card has been especially beneficial for showcasing my products and services."',
    image: Akam,
    name: "Akam B.",
  },
  {
    rating: 4.5,
    reviewText:
      '"Techhype\'s digital business card has completely transformed the way I connect with people. It\'s sleek, modern, and incredibly user-friendly. I love how I can easily share my contact details with just a tap, saving time and making networking more efficient."',
    image: Julie,
    name: "Julie H.",
  },
  {
    rating: 4.5,
    reviewText:
    '" I\'ve tried several digital business card solutions, but Techhype stands out from the rest. The customization options are impressive, allowing me to showcase my brand and personality. Plus, the analytics feature provides valuable insights into how my contacts engage with my card. "',
    image: Jonas,
    name: "Jonas S.",
  },
];
